export interface MusicTrack {
  id: string;
  title: string;
  album: string;
  year: number;
  duration: string;
  audioUrl: string;
  coverUrl: string;
  buyUrl: string;
  downloadUrl: string;
  description: string;
  spotifyUrl?: string;
  spotifyEmbedUrl?: string;
  appleMusicEmbedUrl?: string;
  featured?: boolean;
}

export const mockTracks: MusicTrack[] = [
  {
    id: '1',
    title: 'WRITE MY WRONGS',
    album: '',
    year: 0,
    duration: '3:42',
    audioUrl: '',
    coverUrl: 'https://storage.readdy-site.link/project_files/9eec93be-30e4-4db4-94c1-4bae9d306ad9/9995442a-5703-4dce-af0e-66d97592b4d5_IMG_8322.jpeg?v=1e65545e496786d0b2d13a3eeb176bbf',
    buyUrl: 'https://dirtybirdy.bandcamp.com/track/write-my-wrongs',
    downloadUrl: '#',
    description: '',
    appleMusicEmbedUrl: 'https://embed.music.apple.com/us/album/write-my-wrongs/1784201801?i=1784201804',
    featured: true,
  },
  {
    id: '2',
    title: 'DIRTY',
    album: '',
    year: 0,
    duration: '4:05',
    audioUrl: '',
    coverUrl: 'https://storage.readdy-site.link/project_files/9eec93be-30e4-4db4-94c1-4bae9d306ad9/8ee30136-c43f-4e8b-a104-56f309462da2_IMG_8323.jpeg?v=0210599c0ce7e298d546af3e6f2d8adc',
    buyUrl: 'https://dirtybirdy.bandcamp.com/track/dirty',
    downloadUrl: '#',
    description: '',
    appleMusicEmbedUrl: 'https://embed.music.apple.com/us/album/dirty-single/1757411726?i=1757411729',
    featured: true,
  },
  {
    id: '3',
    title: 'SOMEBODY TOLD ME',
    album: '',
    year: 0,
    duration: '3:18',
    audioUrl: '',
    coverUrl: 'https://storage.readdy-site.link/project_files/9eec93be-30e4-4db4-94c1-4bae9d306ad9/69630bd4-741b-48d9-94d6-c434136e44fa_IMG_8321.jpeg?v=daa279966ccf3e8dc856e7ca2a3d7b43',
    buyUrl: 'https://dirtybirdy.bandcamp.com/track/somebody-told-me-fake-love-explicit',
    downloadUrl: '#',
    description: '',
    appleMusicEmbedUrl: 'https://embed.music.apple.com/us/album/somebody-told-me-fake-love/1634173727?i=1634173736',
    featured: true,
  },
  {
    id: '4',
    title: 'WHAT THEY CALL ME',
    album: '',
    year: 0,
    duration: '4:28',
    audioUrl: '',
    coverUrl: 'https://storage.readdy-site.link/project_files/9eec93be-30e4-4db4-94c1-4bae9d306ad9/1ce4b199-3eba-45a1-90e0-7b3c0e00aa07_What-They-Call-Me-Artwork.jpg?v=7304fafeee6672f625a9dacf290ce9cb',
    buyUrl: 'https://music.apple.com/us/album/what-they-call-me-single/1838404013',
    downloadUrl: '#',
    description: '',
    appleMusicEmbedUrl: 'https://embed.music.apple.com/us/album/what-they-call-me-single/1838404013?i=1838404014',
  },
  {
    id: '5',
    title: 'CAN\'T TELL ME (BOP BOP)',
    album: '',
    year: 0,
    duration: '3:55',
    audioUrl: '',
    coverUrl: 'https://storage.readdy-site.link/project_files/9eec93be-30e4-4db4-94c1-4bae9d306ad9/0e8ac499-554c-45cd-be34-716464a94461_Cant-Tell-MeBop-Bop-Artwork-Cover.jpeg?v=c2679bf0ec414827cbf9c44ceb5b55d3',
    buyUrl: 'https://dirtybirdy.bandcamp.com/track/cant-tell-me-bop-bop',
    downloadUrl: '#',
    description: '',
    appleMusicEmbedUrl: 'https://embed.music.apple.com/us/album/cant-tell-me-bop-bop/1883601671?i=1883601672',
  },
];
